import gql from 'graphql-tag';

export default gql`
  fragment orderFragment on OrderType {
    id
    workflowState
    workflowStateText
    totalPrice
    completedAtText
    chargeId
    paymentState
    paymentStateText
  }
`;
